import { Fragment } from "react";
import { Protocol } from "~/modules/protocols_v4/types";
import { BroadridgeHeader } from "./BroadridgeHeader";
import { BroadridgeIndividualAggregates } from "./BroadridgeIndividualAggregates";
import { VisualizationGrid } from "~/modules/visualization/components/VisualizationGrid";
import { BroadridgeTimeSeriesCard } from "./BroadridgeTimeSeriesCard";
import {
    PlatformSnapshot,
    transformPlatformSnapshotsToTimeSeries,
} from "./facts_platform_snapshots_data";
import { MEASURE_IDS } from "~/consts";
import { BroadridgeNews } from "./BroadridgeNews";
import { BroadridgeDiagram } from "./BroadridgeDiagram";
import { SectionHeader } from "~/components/SectionHeader";

// // // //

interface Props {
    platform: Protocol;
    snapshots: PlatformSnapshot[];
}

export function BroadridgeIndividualPage(props: Props) {
    const { platform, snapshots } = props;

    const totalContracts = transformPlatformSnapshotsToTimeSeries(
        snapshots.filter(
            (each) => each.measure_id === MEASURE_IDS.TotalContracts,
        ),
    );

    const totalCollateralizedFunds = transformPlatformSnapshotsToTimeSeries(
        snapshots.filter(
            (each) => each.measure_id === MEASURE_IDS.TotalCollateralizedFunds,
        ),
    );

    const totalIssuedFunds = transformPlatformSnapshotsToTimeSeries(
        snapshots.filter(
            (each) => each.measure_id === MEASURE_IDS.TotalIssuedFunds,
        ),
    );

    return (
        <Fragment>
            <BroadridgeHeader broadridgeProtocol={platform} />

            <BroadridgeIndividualAggregates
                totalContractsTimeseries={totalContracts}
                totalCollateralizedFundsTimeseries={totalCollateralizedFunds}
                totalIssuedFundsTimeseries={totalIssuedFunds}
            />

            <VisualizationGrid className="my-6">
                <BroadridgeTimeSeriesCard
                    title="Broadridge DLR Metrics"
                    totalContractsTimeseries={totalContracts}
                    totalCollateralizedFundsTimeseries={
                        totalCollateralizedFunds
                    }
                    totalIssuedFundsTimeseries={totalIssuedFunds}
                    columnSpanConfig={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                        xxl: 12,
                    }}
                />

                <div className="col-span-12 sm:col-span-6 md:col-span-12 lg:col-span-6 xl:col-span-6 2xl:col-span-6">
                    <BroadridgeNews />
                </div>

                <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-6 2xl:col-span-6">
                    <SectionHeader label="Transaction Flows" />
                    <div className="px-5 py-12 bg-card rounded-lg shadow-xs border overflow-hidden flex justify-center">
                        <BroadridgeDiagram />
                    </div>
                </div>

                {/* <div className="col-span-12 sm:col-span-6 md:col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-12">
                    <BroadridgeSmartContracts />
                </div> */}
            </VisualizationGrid>
        </Fragment>
    );
}
